import firebase from "firebase/app";
import "firebase/functions";

export async function chatAction(action, data = {}) {
  return (
    await firebase.app().functions().httpsCallable("chatAction")({
      action,
      ...data,
    })
  ).data;
}
export const migrateChatMutes = () => chatAction("migrate");
export const setConnectionMuted = (_uid, targetUid, enabled) =>
  chatAction("mutePerson", { targetUid, enabled });
export const blockUser = (_uid, targetUid) =>
  chatAction("blockPerson", { targetUid, enabled: true });
export const unblockUser = (_uid, targetUid) =>
  chatAction("blockPerson", { targetUid, enabled: false });
export const chatKey = (type, spaceId, stationId) =>
  type === "project"
    ? `project:${spaceId}:${stationId}`
    : type === "workspace"
      ? `workspace:${spaceId}`
      : null;
export const setChatMuted = (type, spaceId, stationId, enabled) =>
  chatAction("muteChat", {
    type,
    spaceId,
    stationId: stationId || null,
    enabled,
  });
export const leaveChatGroup = (type, spaceId, stationId) =>
  chatAction("leaveGroup", { type, spaceId, stationId: stationId || null });
export const respondToCall = (call, status) =>
  call?.callSessionId
    ? chatAction("respondCall", { callId: call.callSessionId, status })
    : Promise.resolve();
export const muteUser = (uid, targetUid) =>
  setConnectionMuted(uid, targetUid, true);
export const unMuteUser = (uid, targetUid) =>
  setConnectionMuted(uid, targetUid, false);

export const getGroupLeaveInfo = (type, spaceId, stationId) =>
  chatAction("groupLeaveInfo", { type, spaceId, stationId: stationId || null });
